import React from "react";

/**
 * VehicleDetailGearboxIcon
 *
 * Icon for vehicle gearbox detail. Used in VehicleDetailsList.
 */
const VehicleDetailGearboxIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1 1V8H16M6 1V15M11 1V15M16 1V15"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VehicleDetailGearboxIcon;
